import { render } from "./showCallMe.vue?vue&type=template&id=74ea66c4&scoped=true"
const script = {}

import "./showCallMe.vue?vue&type=style&index=0&id=74ea66c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ea66c4"]])

export default __exports__